import { makeStyles } from '@material-ui/core/styles';
import {
  Box,
  Button,
  CircularProgress,
  Typography,
} from '@material-ui/core';
import LocalOfferOutlinedIcon from '@material-ui/icons/LocalOfferOutlined';
import MaterialModal from 'common/components/modal/materialModal';
import { Field, reduxForm } from 'redux-form';
import { InputLabelOutlined } from 'common/components/fields/fields';
import { FORM_RULES } from 'helpers/validations';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import {
  BUTTON_TEXT_COLOR,
  BUTTON_BACKGROUND_COLOR,
} from 'config/consts';
import React from 'react';
import { isMobile } from 'react-device-detect';

const useStyles = makeStyles((theme) => ({
  paper: {
    maxHeight: isMobile ? '100vh' : '95vh',
  },
  wrapper: {
    backgroundColor: theme.palette.common.white,
    padding: theme.spacing(4, isMobile ? 3 : 6),
    display: 'flex',
    flexDirection: 'column',
    minHeight: isMobile ? '100vh' : 'auto',
    width: '100%',
    boxSizing: 'border-box',
  },
  header: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: isMobile ? 'center' : 'flex-start',
    textAlign: isMobile ? 'center' : 'left',
    gap: theme.spacing(1.5),
    marginBottom: theme.spacing(4),
  },
  iconBadge: {
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: 56,
    height: 56,
    borderRadius: '50%',
    backgroundColor: theme.palette.primary.light,
    color: theme.palette.primary.main,
  },
  form: {
    width: '100%',
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(4),
  },
  fieldContainer: {
    width: '100%',
    maxWidth: 520,
    alignSelf: isMobile ? 'center' : 'flex-start',
  },
  actions: {
    display: 'flex',
    justifyContent: isMobile ? 'center' : 'flex-end',
  },
  submitButton: {
    background: BUTTON_BACKGROUND_COLOR,
    color: BUTTON_TEXT_COLOR,
    borderRadius: theme.shape.borderRadius * 2,
    padding: theme.spacing(1.5, isMobile ? 5 : 8),
    fontSize: '1rem',
    fontWeight: 600,
    boxShadow: '0px 8px 20px rgba(0, 0, 0, 0.12)',
    '&:hover': {
      background: BUTTON_BACKGROUND_COLOR,
      filter: 'brightness(0.95)',
    },
  },
  buttonProgress: {
    color: BUTTON_TEXT_COLOR,
    marginLeft: theme.spacing(1.5),
  },
}));

let CouponApplyModal = function ({
  open,
  setOpen,
  handleSubmit,
  submitting,
  onApply = () => {},
  reset,
  loading = false,
}) {
  const classes = useStyles();

  const handleApply = (values) => {
    if (onApply) {
      onApply(values);
    }
    reset();
    setOpen(false);
  };

  return (
    <MaterialModal
      open={open}
      onClose={() => {
        reset();
        setOpen(false);
      }}
      showTitle
      PaperProps={{ classes: { root: classes.paper } }}
      fullScreen={isMobile ? true : false}
    >
      <Box className={classes.wrapper}>
        <Box className={classes.header}>
          <Box className={classes.iconBadge}>
            <LocalOfferOutlinedIcon fontSize="large" />
          </Box>
          <Box>
            <Typography variant="h5" component="h2">
              Aplicar cupom de desconto
            </Typography>
            <Typography variant="body2" color="textSecondary">
              Insira o código do seu cupom abaixo para validar o benefício antes de finalizar o pedido.
            </Typography>
          </Box>
        </Box>

        <form onSubmit={handleSubmit(handleApply)} className={classes.form}>
          <Box className={classes.fieldContainer}>
            <Field
              component={InputLabelOutlined}
              label="Código do cupom"
              name="coupon_code"
              validate={[FORM_RULES.required]}
              helperText="Informe o código exatamente como recebido"
              autoFocus
            />
          </Box>

          <Box className={classes.actions}>
            <Button
              type="submit"
              className={classes.submitButton}
              disabled={submitting || loading}
            >
              {submitting || loading ? 'Aplicando' : 'Aplicar cupom'}
              {(submitting || loading) && (
                <CircularProgress size={20} className={classes.buttonProgress} />
              )}
            </Button>
          </Box>
        </form>
      </Box>
    </MaterialModal>
  );
}

CouponApplyModal = reduxForm({ form: 'couponApplyForm' })(CouponApplyModal);

const mapStateToProps = (state) => {
  return {
    auth: state.auth,
  };
};
const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(
    {
      // TODO: actions
    },
    dispatch
  );
};
export default connect(mapStateToProps, mapDispatchToProps)(CouponApplyModal);